export default __webpack_public_path__ + "static/media/7Cisco.debb17fd.svg";